module.exports = __webpack_public_path__ + "static/trevin-b9e1f497b6d8ae5cf453c6ae67b33d2b.jpg";